const PaymentExpressResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        /* 'https://uat.paymentexpress.com/pxmi3/pos.aspx', */
        appConfig.apiBaseUrl + 'PaymentExpressProxy',
        apiRequestParams.defaults(),
        {
            // Note: All the requests are the same, but I've given them different names
            // so that the calling code is easier to understand.
            initiate: {
                method: 'POST',
            },
            buttonPress: {
                method: 'POST',
            },
            status: {
                method: 'POST',
            },
        }
    );
};

module.exports = PaymentExpressResource;
